module.exports = __webpack_public_path__ + "static/media/recuperados.c8fdf0c0.png";